import { useSelector } from 'react-redux';

import { DIALOG_VARIANT } from 'constants/dialog';
import { dialogVariantSelector } from 'store/entities/ui/slice';

import { AddUserDialog } from './AddUserDialog';
import { ConfirmationDialog } from './ConfirmationDialog';
import { ConfirmationDialogWithInput } from './ConfirmationDialogWithInput';
import { CreateMasterDashboardDialog } from './CreateMasterDashboardDialog';
import { DuplicateProjectDialog } from './DuplicateProjectDialog';
import { EditFrameworkRecipientDeadlineDialog } from './EditFrameworkRecipientDeadlineDialog';
import { ExportEntriesDialog } from './ExportEntriesDialog';
import { InvalidInvitesDialog } from './InvalidInvitesDialog';
import { KeyEventsDialog } from './KeyEventsDialog';
import { LeadersPermissionsDialog } from './LeadersPermissionsDialog';
import { NomineeModal } from './NomineeModal';
import { OrganisationUserDetailsDialog } from './OrganisationUserDetailsDialog';
import { PasswordUpdateDialog } from './PasswordUpdateDialog';
import { RenameDialog } from './RenameDialog';
import { ResetPasswordDialog } from './ResetPasswordDialog';
import { SaveCreatedMasterDashboardDialog } from './SaveCreatedMasterDashboardDialog';
import { StartFeedbackRoundDialog } from './StartFeedbackRoundDialog';

export const DialogManager = () => {
  const variant = useSelector(dialogVariantSelector);

  switch (variant) {
    case DIALOG_VARIANT.RENAME:
      return <RenameDialog />;
    case DIALOG_VARIANT.PASS_UPDATE:
      return <PasswordUpdateDialog />;
    case DIALOG_VARIANT.CREATE_MASTER_DASHBOARD:
      return <CreateMasterDashboardDialog />;
    case DIALOG_VARIANT.CONFIRMATION:
      return <ConfirmationDialog />;
    case DIALOG_VARIANT.CONFIRMATION_WITH_INPUT:
      return <ConfirmationDialogWithInput />;
    case DIALOG_VARIANT.DUPLICATE_PROJECT:
      return <DuplicateProjectDialog />;
    case DIALOG_VARIANT.RESET_PASSWORD:
      return <ResetPasswordDialog />;
    case DIALOG_VARIANT.ADD_USER:
      return <AddUserDialog />;
    case DIALOG_VARIANT.ORGANISATION_USER_DETAILS:
      return <OrganisationUserDetailsDialog />;
    case DIALOG_VARIANT.LEADERS_PERMISSIONS:
      return <LeadersPermissionsDialog />;
    case DIALOG_VARIANT.EXPORT_ENTRIES:
      return <ExportEntriesDialog />;
    case DIALOG_VARIANT.SAVE_CREATED_MASTER_DASHBOARD:
      return <SaveCreatedMasterDashboardDialog />;
    case DIALOG_VARIANT.START_FEEDBACK_ROUND:
      return <StartFeedbackRoundDialog />;
    case DIALOG_VARIANT.EDIT_FRAMEWORK_RECIPIENT_DEADLINE:
      return <EditFrameworkRecipientDeadlineDialog />;
    case DIALOG_VARIANT.KEY_EVENTS:
      return <KeyEventsDialog />;
    case DIALOG_VARIANT.INVALID_INVITES:
      return <InvalidInvitesDialog />;
    case DIALOG_VARIANT.NOMINEE_MODAL:
      return <NomineeModal />;
    default:
      return null;
  }
};
